/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRegimenDrugs } from 'app/entities/regimen-drug/regimen-drug.reducer';
import { createEntity, getEntity, reset, updateEntity } from './drug-constraint.reducer';

export const DrugConstraintUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const regimenDrugs = useAppSelector(state => state.regimenDrug.entities);
  const drugConstraintEntity = useAppSelector(state => state.drugConstraint.entity);
  const loading = useAppSelector(state => state.drugConstraint.loading);
  const updating = useAppSelector(state => state.drugConstraint.updating);
  const updateSuccess = useAppSelector(state => state.drugConstraint.updateSuccess);

  const handleClose = () => {
    navigate(`/drug-constraint${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRegimenDrugs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...drugConstraintEntity,
      ...values,
      drug: regimenDrugs.find(it => it.id.toString() === values.drug?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...drugConstraintEntity,
          drug: drugConstraintEntity?.drug?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.drugConstraint.home.createOrEditLabel" data-cy="DrugConstraintCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.drugConstraint.home.createOrEditLabel">Create or edit a DrugConstraint</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="drug-constraint-id"
                  label={translate('tinyMedicRestApp.drugConstraint.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.description')}
                id="drug-constraint-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.type')}
                id="drug-constraint-type"
                name="type"
                data-cy="type"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.value')}
                id="drug-constraint-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.priority')}
                id="drug-constraint-priority"
                name="priority"
                data-cy="priority"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.unit')}
                id="drug-constraint-unit"
                name="unit"
                data-cy="unit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.startConstraint')}
                id="drug-constraint-startConstraint"
                name="startConstraint"
                data-cy="startConstraint"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.endConstraint')}
                id="drug-constraint-endConstraint"
                name="endConstraint"
                data-cy="endConstraint"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.active')}
                id="drug-constraint-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.cursor')}
                id="drug-constraint-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.lastUpdated')}
                id="drug-constraint-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.microSec')}
                id="drug-constraint-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.drugConstraint.timestampEntry')}
                id="drug-constraint-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="drug-constraint-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.drugConstraint.drug')}
                type="select"
              >
                <option value="" key="0" />
                {regimenDrugs
                  ? regimenDrugs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/drug-constraint" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DrugConstraintUpdate;
